import { render, staticRenderFns } from "./TekNatijaUzi.vue?vue&type=template&id=50962d01"
import script from "./TekNatijaUzi.vue?vue&type=script&lang=js"
export * from "./TekNatijaUzi.vue?vue&type=script&lang=js"
import style0 from "./TekNatijaUzi.vue?vue&type=style&index=0&id=50962d01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports